<script lang="ts" setup>
  import { onMounted, ref, toRefs } from 'vue'

  import type { BusinessPartnerJsonldDefaultReadGlobalSearchSync, EffortJsonldVueGlobalSearchDefaultReadSync } from '@/api'
  import { useGeneratedBusinessPartnerStore } from '@/stores'
  import PreviewCommon from '@/components/global-search/PreviewCommon.vue'
  import { UserCircleIcon } from '@heroicons/vue/24/outline'

  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()

  const props = defineProps<{ data: EffortJsonldVueGlobalSearchDefaultReadSync; omitActions?: boolean }>()
  const { data, omitActions } = toRefs(props)

  const emit = defineEmits<{
    effortSelected: [effort: EffortJsonldVueGlobalSearchDefaultReadSync]
    shortcutClicked: []
    showOverlay: [EffortJsonldVueGlobalSearchDefaultReadSync]
  }>()
  //const partnerStore = useGeneratedBusinessPartnerStore()
  //const partner = ref<BusinessPartnerJsonldDefaultReadGlobalSearchSync>()
  onMounted(async () => {
    //partner.value = data.value.partner ? await partnerStore.fetchByIri(data.value.partner).then((d) => d.value) : undefined
  })

  // const budgetOverrun = data.value.spentHours > data.value.availableHours
</script>

<template>
  <PreviewCommon
    :alt="t('Business partner')"
    :data="data"
    :icon="UserCircleIcon"
    :omit-actions="omitActions"
    @effort-selected="(e) => emit('effortSelected', e)"
    @shortcut-clicked="emit('shortcutClicked')"></PreviewCommon>
</template>
